export default "__VITE_ASSET__Dku5Yy8C__"